import React from 'react';
import { useOneTrust } from './useOneTrust';

export const OneTrustPopup: React.FC = () => {
  const { maybeLoadOneTrust } = useOneTrust();

  React.useEffect(() => {
    maybeLoadOneTrust();
  }, [maybeLoadOneTrust]);

  return null;
};
